import { httpGetAndParse, httpPost } from '../../../utils/fetchService';

export const fetchJobQueueStatusReports = () =>
  httpGetAndParse({
    route: `/api/admin/custom-reports/job-queue-status-reports`,
    errorMessage: 'Fetching Job Queue Status Reports Failed',
  });

export const terminateStuckCalcJob = req =>
  httpPost({
    route: `/api/admin/custom-reports/terminate-stuck-calc-job`,
    body: { ...req },
    successMessage: 'Terminating Stuck Calc Job Success',
    errorMessage: 'Terminating Stuck Calc Job Failed',
  });
